import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { authAPI } from '../services/api';
import AuthCard from './AuthCard';
import styles from './auth.module.css';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authAPI.forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError(t('auth.forgotPassword.genericError'));
    }

    setLoading(false);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box className={styles.wrap}>
        <AuthCard>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            {t('auth.forgotPassword.title')}
          </Typography>

          {submitted ? (
            <>
              <Alert severity="success" className={styles.alert}>
                {t('auth.forgotPassword.sent')}
              </Alert>
              <Box className={`${styles.linkRowCenter} ${styles.mt3}`}>
                <Link to="/login" className={styles.link}>
                  <Typography variant="body2" color="primary">
                    {t('auth.backToSignIn')}
                  </Typography>
                </Link>
              </Box>
            </>
          ) : (
            <>
              <Typography variant="body2" color="text.secondary" className={styles.subtitle}>
                {t('auth.forgotPassword.subtitle')}
              </Typography>

              {error && (
                <Alert severity="error" className={styles.alert}>
                  {error}
                </Alert>
              )}

              <Box component="form" onSubmit={handleSubmit} className={styles.mt2}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label={t('auth.email')}
                  name="email"
                  autoComplete="email"
                  autoFocus
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  className={styles.submitBtnLg}
                  disabled={loading}
                >
                  {loading ? t('auth.forgotPassword.submitting') : t('auth.forgotPassword.submit')}
                </Button>
                <Box className={`${styles.linkRowCenter} ${styles.mt1}`}>
                  <Link to="/login" className={styles.link}>
                    <Typography variant="body2" color="primary">
                      {t('auth.backToSignIn')}
                    </Typography>
                  </Link>
                </Box>
              </Box>
            </>
          )}
        </AuthCard>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
